module.exports = __webpack_public_path__ + "static/img/code-app.149befe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/code-app.png
// module id = PZUK
// module chunks = 1